<template>
  <div class="login bpo-main-body">
    <div style="height:80px">
      <el-header height="50px">
      </el-header>
    </div>
    <div style="text-align: center;margin:0 auto;position:absolute;top:50%;left:50%;transform: translate(-50%, -50%);">
      <el-row style="margin-bottom: 10px;">
        <el-col>
          <span style="font-size: 30px;font-weight: bold;color:rgb(89,89,89);">信服集团管理系统</span>
        </el-col>
      </el-row>
      <el-card style="width: 480px;height: 400px;display: inline-block" @keyup.enter.native="handleLogin">
        <el-row style="margin-bottom: 30px;margin-top: 20px;">
          <el-col class="col-text-align"><span style="font-size: 20px;">Sign in to your account</span></el-col>
        </el-row>
        <el-form ref="form" :model="loginForm" label-width="0" class="col-text-align">
          <el-form-item style="margin-bottom: 30px;">
            <el-input placeholder="请输入用户名或手机号" v-model="loginForm.userId" maxlength="32" clearable></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-input type="password" autocomplete="new-password" show-password placeholder="请输入密码" maxlength="16" v-model="loginForm.password" clearable></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;margin-left: 30px;text-align: left;">
            <el-form-item v-if="!_.isEmpty(errMsg)">
              <el-col><span style="color: red;">{{errMsg}}</span></el-col>
            </el-form-item>
            <el-col>
              <el-checkbox label="记住我" v-model="loginForm.isRememberFlag"/>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button class="common-button iconfont icon-denglu1" style="width: 380px;height: 40px;" @click="handleLogin"><span>登录</span></el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div style="height:40px;position: fixed;bottom: 0;width: 100%">
      <el-row>
        <el-col class="col-text-align">
          <footer>
            <p style="white-space: nowrap;margin: 0;font-weight: 400;font-size: 14px;color: #606266">
              <span>©浙江信服会计师事务所有限公司 All Rights Reserved.</span>
            </p>
            <p style="white-space: nowrap;margin: 0;font-weight: 400;font-size: 12px;">
              <el-link href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202002648" target="_blank">浙公网安备33010202002648号</el-link>
              <el-link href="https://beian.miit.gov.cn" target="_blank">浙ICP备2023017537号</el-link>
            </p>
          </footer>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Crypto from '@/crypto'
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        userId: '',
        password: '',
        isRememberFlag: true,
      },
      errMsg: ''
    }
  },
  methods: {
    handleLogin() {
      this.errMsg = ''
      const param = new URLSearchParams()
      param.append('usrCd', this.loginForm.userId)
      param.append('usrPwd', this.loginForm.password)
      this.axios.post('doLogin', param).then(res => {
        var retResult = res.data.retResult
        if (retResult.state == 0) {
          this.$store.commit('saveToken', retResult.accessToken)
          this.$store.commit('saveLoginUser', retResult.loginUsr)
          this.$store.commit('saveRememberUser', this.loginForm)
          if (this.loginForm.isRememberFlag) {
            var usrCd = this.loginForm.userId
            var pwd = this.loginForm.password
            var ckstr = this.setCookie('usrCd', escape(Crypto.set(usrCd)), 'usrPwd', escape(Crypto.set(pwd)), 30);
            document.cookie = ckstr;
          } else {
            document.cookie = "usrCd=&usrPwd=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          }
          if (this.$store.state.showAlerFg != '') {
            this.$store.commit('saveShowAlerFg', '')
          }
          var routerList = retResult.loginUsr.routerList
          const { routes } = this.$router.options
          const routeData = routes.find(r => r.path === '/sws/main')
          let aRouter = this.common.setRoute2(routerList)
          routeData.children = aRouter
          aRouter.forEach(child => {
            if (!this.$router.getRoutes().some(r => r.name === child.name)) {
              this.$router.addRoute('main', child);
            }
          })
          this.$store.commit('saveRouteList', routerList)
          this.$router.push({ name: routerList[0].componentNm })
        } else {
          this.errMsg = retResult.errMsg
        }
      })
    },
    getCookie(cname, index) {
      var name = cname + '=';
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c ='';
        if (ca[i].indexOf('&') > 0) {
          c = ca[i].split('&')[index];
        } else {
          c = ca[i]
        }
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    },
    setCookie(cname, cvalue, cname2, cvalue2, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = 'expires=' + d.toUTCString();
      return cname + "=" + cvalue + "&" + cname2 + "=" + cvalue2 + ";" + expires + ";path=/;";
    }
  },
  created: function() {
    var ck = document.cookie;
    if (!_.isEmpty(ck)) {
      this.loginForm.isRememberFlag = true;
      var usrCd = this.getCookie('usrCd', 0);
      var pwd = this.getCookie('usrPwd', 1);
      this.loginForm.userId = Crypto.get(unescape(usrCd));
      this.loginForm.password = Crypto.get(unescape(pwd));
    } else {
      this.loginForm.isRememberFlag = false;
    }
  }
}
</script>

<style scoped>
.login {
  height: 100%;
  width: 100%;
  position: fixed;
}
.el-input {
  width: 380px;
  height: 36px;
  border-radius: 4px;
}
</style>
